const isPublished = (state = {}, action) => {
  switch (action.type) {
    case 'IS_PUBLISHED':
      return {
        ...state,
        [action.appname]: action.isPublished,
      };

    default:
      return state;
  }
};

export default isPublished;
